import Helper from './Helper';
import Swiper from "swiper/bundle";

class Esg {
  constructor() {
    this.cardButtonsSelector = '.js-esg-button';
    this.imageButtonSelector = '.js-esg-image-button';
    this.listsSelector = '.js-esg-card-list';
    this.sliderSelector = '.js-esg-swiper';
    this.sliderImagesSelector = '.esg-swiper-slide__image';
    this.sliderTextSelector = '.js-esg-swiper-text';
    this.sliderContainerSelector = ".swiper-container";
    
    this.cardButtons = document.querySelectorAll(this.cardButtonsSelector);
    this.imageButton = document.querySelector(this.imageButtonSelector);
    this.lists = document.querySelectorAll(this.listsSelector);
    this.slider = document.querySelector(this.sliderSelector);
    this.sliderImages = document.querySelectorAll(this.sliderImagesSelector);
    this.sliderText = document.querySelectorAll(this.sliderTextSelector);

    this.sliderBreakpoint = 768;
    this.sliders = document.querySelectorAll(this.sliderSelector);
    this.slidersArray = Array.prototype.slice.call(this.sliders);
    this.currentScreenWidth = window.screen.width;
    this.previousScreenWidth = window.screen.width;
    this.sliderIsInitiated = false;
    this.currentlyDesktop = "";
    this.swiperInstances = [];

    if(this.cardButtons){
      this.bindCardButtons();
    }

    if(this.imageButton){
      this.bindImageButton();
    }

    if(this.lists){
      this.bindLists();
    }

    if(this.slider){
      this.bindSliderText();
      this.bindSliderEvent();
      this.bindSlider();
    }
  }

  bindCardButtons(){
    this.cardButtons.forEach(button => {
      button.addEventListener('click', () => {
        Helper.toggleClass(button.closest('.ns-esg-card'), 'ns-esg-card--active');
      });
    });
  }

  bindCards(){
    this.cards.forEach(card => {
      card.addEventListener('click', () => {
        Helper.toggleClass(card, 'ns-esg-card--active');
      });
    });
  }

  bindImageButton(){
    this.imageButton.addEventListener('click', () => {
      Helper.toggleClass(this.imageButton.closest('.ns-esg-image'), 'ns-esg-image--active');
    });
  }

  bindLists(){
    this.lists.forEach(list => {
      list.closest('.ns-esg-card__front').nextElementSibling.insertAdjacentElement('afterbegin', list.cloneNode(true));
    });
  }

  bindSliderText(){
    let sliderTextContainer = document.createElement('div');
    sliderTextContainer.classList.add('swiper-text-container');
    this.sliderText.forEach((text, index) => {
      if(index == 0){ text.classList.add('slide-active'); }
      sliderTextContainer.insertAdjacentElement('beforeend', text);
    }); 
    this.sliderImages[0].classList.add('slide-active');
    this.slider.insertAdjacentElement('beforeend', sliderTextContainer);
    let container = document.querySelector('.swiper-text-container');
    let activeSlide = document.querySelector('.swiper-text-container > .slide-active');
    container.style.height = activeSlide.clientHeight + "px";
  }

  bindSliderEvent(){
    this.sliderImages.forEach((image, index) => {
      if (this.previousScreenWidth > this.sliderBreakpoint) {
        image.addEventListener("click", e => {
          this.sliderImages.forEach(image => { image.classList.remove('slide-active'); });
          image.classList.add('slide-active');
          this.bindSliderTextEvent(index);
        });
      }
    });
  }

  bindSliderTextEvent(index){
    document.querySelectorAll('.swiper-text-container > div').forEach(div => { div.classList.remove('slide-active'); });
    let container = document.querySelector('.swiper-text-container');
    let activeText = document.querySelector('.swiper-text-container > div:nth-child(' + (index + 1) + ')');
    activeText.classList.add('slide-active');
    container.style.height = activeText.clientHeight + "px";
  }

  bindSlider(){
    if (this.currentScreenWidth < this.sliderBreakpoint) {
      this.currentlyDesktop = false;
      this.initSwipersMobile();
    } else {
      this.currentlyDesktop = true;
    }

    window.addEventListener("resize", () => {
      const vw = window.screen.width;

      if (this.previousScreenWidth < this.sliderBreakpoint) {
        if (vw > this.sliderBreakpoint) {
          this.destroySwipers();
        }
      }

      if (this.previousScreenWidth > this.sliderBreakpoint) {
        if (vw < this.sliderBreakpoint) {
          this.destroySwipers();
          this.initSwipersMobile();
        }
      }

      this.previousScreenWidth = vw;
    });
  }

  initSwipersMobile(){
    this.slidersArray.forEach((slider, index) => {
      const swiperContainer = slider.querySelector(
        this.sliderContainerSelector
      );
      let swiperConfig = {
        speed: 600,
        parallax: true,
        slidesPerView: 'auto',
        spaceBetween: 45,
        centeredSlides: true
      }
      const instance = new Swiper(swiperContainer, swiperConfig);
      this.swiperInstances.push(instance);

      instance.on('slideChange', () => {
        this.bindSliderTextEvent(instance.activeIndex);
      });
    });
  }

  destroySwipers() {
    this.bindSliderEvent();
    this.swiperInstances.forEach((instance) => {
      instance.destroy(true, true);
    });
  }

} export default Esg;
